import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, Link, Pagination, Select, SpaceBetween, Table, TextFilter, TruncatedText } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { format, parse } from 'date-fns';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getTipoDTE, getUrlVersion, normalizeDate, setData, setLoading, setParameters } from '../../../../commons/functions';


type ItemEnterprise = {
  label: string;
  value: string;
};
const pageSize = 15;
export const AdminMovementsHaulmerPage = () => {
  //const storeAdmin = useStoreAdmin();
  const { menu, parameters } = useGlobalState();
  const { navigate } = useRouter();
  const [selectedEnterprise, setSelectedEnterprise] = useState<ItemEnterprise>({ label: "CPV", value: "CPV" });
  const [selectedDTEType, setSelectedDTEType] = useState<ItemEnterprise>({ label: "Emitidos", value: "issued" });
  const [DTE, setDTE] = useState<any[]>([]);


  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filterValue, setFilterValue] = useState("");

  const filtered: any[] = DTE.filter((item) => {
    const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
    const text = [item?.RUTIssuer, item?.number.toString(), item?.RUTReceiver].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
    return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
  });
  const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);

  const handleGetDTE = async (item: any) => {
    try {
      setLoading(true);

      let body = {
        enterprise: selectedEnterprise?.value,
        dteType: item.TipoDTE,
        folio: item.Folio,
        RUT: selectedDTEType.value === "issued" ? "65289080-6" : item.RUTEmisor + "-" + item.DV,
        orderBy: "DTEDate",
        order: "DESC",
        columns: "*, FORMAT(DTEDate, 'dd-MM-yyyy') as DTEDate2",
      }
      const rut = selectedDTEType.value === "issued" ? item.RUTRecep + "-" + item.DV : item.RUTEmisor + "-" + item.DV;
      const type = selectedDTEType.value === "issued" ? "EMITIDO" : "RECIBIDO";
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': `/private/admin/movements/haulmer/get`,
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();
      if (result.code === 0) {
        if (result.DTE && result.DTE.pdf) {
          downloadBase64PDF(result.DTE.pdf, `DTE.${type}.${rut}.${item.Folio}.pdf`);
        }
        //setDTE(result.DTE ?? []);
        ////console.log(result.DTE.length + " DTEs retrieved");
      } else {
        addNotification(result.status, "error", setData);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  }
  const handleGetDTEs = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': `/private/admin/movements/haulmer/dte`,
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({
          ...(selectedDTEType?.value === "issued" ? { RUTIssuer: selectedEnterprise?.value === "CPV" ? "65289080-6" : "76086428-5" } : { RUTReceiver: selectedEnterprise?.value === "CPV" ? "65289080-6" : "76086428-5" }),
          start: normalizeDate(parameters.startDate),
          end: normalizeDate(parameters.endDate),
          orderBy: "DTEDate",
          order: "DESC",
          columns: "*, FORMAT(DTEDate, 'dd-MM-yyyy') as DTEDate2",
        }),
      });

      const result = await response.json();
      if (result.code === 0) {
        setDTE(result.DTE ?? []);
        //console.log(result.DTE.length + " DTEs retrieved");
      } else {
        addNotification(result.status, "error", setData);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    //selectedDTEType == null && setSelectedDTEType({ label: "Emitidos", value: "issued" });
    //selectedEnterprise == null && setSelectedEnterprise({ label: "CPV", value: "CPV" });
  }, []);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Control de DTE</Header>
          <SpaceBetween direction="horizontal" size="xs">
            <div style={{ width: 100 }}>
              <FormField label="Empresa">
                <Select
                  selectedOption={selectedEnterprise}
                  onChange={({ detail }) => {
                    setSelectedEnterprise(detail.selectedOption as ItemEnterprise)
                    setDTE([]); // Clear DTE data on date change
                  }}
                  options={[
                    { label: "CPV", value: "CPV" },
                    { label: "RAC", value: "RAC" },
                  ]}
                />
              </FormField>
            </div>
            <div style={{ width: 120 }}>
              <FormField label="Tipo DTE">
                <Select
                  selectedOption={selectedDTEType}
                  onChange={({ detail }) => {
                    setSelectedDTEType(detail.selectedOption as ItemEnterprise)
                    setDTE([]); // Clear DTE data on date change
                  }}
                  options={[
                    { label: "Emitidos", value: "issued" },
                    { label: "Recibidos", value: "received" },
                  ]}
                />
              </FormField>
            </div>
            <FormField label="Intervalo">
              <DRPicker start={parameters.startDate} end={parameters.endDate}
                onConfirm={(startDate: string, endDate: string) => {
                  const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                  setParameters(updatedParameters);
                  setDTE([]); // Clear DTE data on date change
                }}
              />
            </FormField>
            <FormField label="&nbsp;">
              <Button style={{ root: btnIconForm }} onClick={() => handleGetDTEs()}><Icon path={mdiMagnify} size={1} /></Button>
            </FormField>
            {DTE && DTE.length > 0 && (
              <Table
                cellVerticalAlign="top"
                filter={filtered ? (
                  <TextFilter
                    filteringPlaceholder="Filtrar"
                    filteringText={filterValue}
                    onChange={({ detail }) => {
                      setFilterValue(detail.filteringText);
                      setCurrentPageIndex(1);
                    }}
                  />
                ) : undefined}
                pagination={
                  filtered.length > pageSize && (
                    <Pagination
                      currentPageIndex={currentPageIndex}
                      pagesCount={Math.ceil(filtered.length / pageSize)}
                      onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                    />
                  )
                }
                variant='embedded'
                stickyHeader
                columnDefinitions={[
                  {
                    id: 'Folio', header: 'Folio',
                    cell: (item) => (
                      <FormField label={
                        <Link onClick={() => handleGetDTE(item)}>
                          {item.number}
                        </Link>}
                        constraintText={getTipoDTE(item.DTEType).shortLabel}
                      />
                    ),
                    width: 50,
                  },
                  {
                    id: 'FchEmis', header: 'Emisión', cell: (item) => format(parse(item?.DTEDate, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") || "",
                    width: 150
                  },
                  {
                    id: 'RznSoc', header: 'Razón social', cell: (item) => <TruncatedText>{selectedDTEType.value == "issued" ? item?.json?.Encabezado?.Receptor?.RznSocRecep : item?.json?.Encabezado?.Emisor?.RznSoc}</TruncatedText>,
                    minWidth: 250
                  },
                  {
                    id: 'detail', header: 'Neto/IVA',
                    width: 150,
                    cell: (item) => <FormField label={`${formatCurrency(item?.NET || 0, "CLP")}`}>{`${formatCurrency(item?.VAT || 0, "CLP")}`}</FormField>,

                  },
                  {
                    id: 'value', header: 'Total',
                    width: 150,
                    cell: (item) => <b>{formatCurrency(item?.GROSS || 0, "CLP")}</b>,

                  },

                ]}

                items={paginated}
                loadingText="Cargando DTEs..."
              />
            )}
          </SpaceBetween>
        </SpaceBetween>
      }
    />
  );
};


function downloadBase64PDF(base64Data: string, fileName: string) {
  // Decode Base64 string to binary
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob from the bytes
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  // Create a link element for download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName.endsWith('.pdf') ? fileName : fileName + '.pdf';
  link.click();

  // Clean up object URL
  URL.revokeObjectURL(link.href);
}